import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import auth from '../Middleware/auth'
// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'


import Truckers from 'src/pages/Truckers/Truckers.vue'
import EditTruckers from 'src/pages/Truckers/EditTrucker.vue'
import Price from '../pages/Price/Price.vue'
import AddOns from '../pages/AddOns/AddOns.vue'
import Login from '../pages/Auth/Login.vue'
import ThankYou from '../pages/Auth/ThankYou.vue'
import TruckerHistory from '../pages/Truckers/TruckerHistory.vue'

import Step from '../pages/Step/Step.vue'

import TranslateEmail from '../pages/TranslateEmail/TranslateEmail.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    name:'truckers',
    redirect: '/admin/truckers',
    meta: {
      reqAuth: true,
    }
  },

  {
    path:'/email/:mail/locale/:locale/token/:token',
    name:'translate_email',
    component:TranslateEmail,
    meta: {
      reqGuest: true
    }

  },
  
  {
    path:'/registration/:token?',
    name:'registration',
    component:Step,
    meta: {
      reqGuest: true
    }
  },

  {
    path:'/thank-you/:token?',
    name:'thank-you',
    component:ThankYou,
    meta: {
      reqGuest: true
    }
  },

  {
    path: '/login',
    name:'login',
    component: Login,
    meta: {
      reqGuest: true
    }
  },

  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    meta: {
      reqAuth: true,
      reqRole: 'admin',
      gate:'view_truckers'
    },
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        meta: {
          reqAuth: true,
          reqRole: 'admin'
        },
      },
      {
        path: 'truckers',
        name: 'truckers',
        component: Truckers,
        meta: {
          reqAuth: true,
          reqRole: 'admin',
          gate:'view_truckers'
        }
      },
      {
        path: 'truckers/edit/:id',
        name: 'EditTrucker',
        component: EditTruckers,
        meta: {
          reqAuth: true,
          reqRole: 'admin',
          gate:'edit_truckers'
        },
      },
      {
        path: 'price',
        name: 'Pris',
        component: Price,
        meta: {
          reqAuth: true,
          reqRole: 'admin',
          gate:'view_prices'
        },
      },
      {
        path: 'add-ons',
        name: 'add ons',
        component: AddOns,
        meta: {
          reqAuth: true,
          reqRole: 'admin',
          gate:'view_add_on'
        },
      },
      {
        path: 'user',
        name: 'Profil',
        component: UserProfile,
        meta: {
          reqAuth: true,
          reqRole: 'admin',
          gate:'view_profile'

        },
      },
      {
        path: 'trucker-history/:id',
        name: 'trucker_history',
        component: TruckerHistory,
        meta: {
          reqAuth: true,
          reqRole: 'admin',
          gate:'view_profile'

        },
      },

      
      
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
